import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";

const CardTarefaStatusChange = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        label="Status alvo"
                        info="Filtrar por status de destino da tarefa (os valores dependem do workflow configurado)"
                        input={
                            <MultiSelect
                                options={[
                                    { value: "A Fazer", label: "A Fazer" },
                                    { value: "Em Progresso", label: "Em Progresso" },
                                    { value: "Concluído", label: "Concluído" },
                                ]}
                                onValueChange={(e) =>
                                    changeActionState({ name: "tarefaTargetStatus", value: e })
                                }
                                defaultValue={actionState?.tarefaTargetStatus}
                                placeholder="Selecionar status (opcional)"
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <RowInput
                        label="Usuário atribuído"
                        info="Filtrar por usuário atribuído na tarefa"
                        input={
                            <MultiSelect
                                options={users}
                                onValueChange={(e) =>
                                    changeActionState({ name: "tarefaUsersAssign", value: e })
                                }
                                defaultValue={actionState?.tarefaUsersAssign}
                                placeholder="Selecionar usuários (opcional)"
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardTarefaStatusChange;
